import React from 'react';

const PrivacyPolicySeomatic = () => {
  const containerStyle = {
    padding: '20px',
    marginTop: '60px',
    maxWidth: '800px',
    marginLeft: 'auto',
    marginRight: 'auto',
    fontFamily: 'Arial, sans-serif',
    lineHeight: '1.6',
    backgroundColor: '#ffffff',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
  };

  const headerStyle = {
    color: '#111',
  };

  const paragraphStyle = {
    color: '#333',
  };

  const linkStyle = {
    color: '#007BFF',
    textDecoration: 'none',
  };

  return (
    <div style={containerStyle}>
        <h1 style={headerStyle}>Privacy Policy</h1>
        <p style={paragraphStyle}><strong>Effective Date:</strong> 17.08.2026</p>

        <p style={paragraphStyle}>At Seomatic, we respect your privacy and are committed to protecting your personal information. This Privacy Policy explains how the Chrome extension handles data when you use it.</p>

        <h2 style={headerStyle}>1. Data Collection</h2>
        <p style={paragraphStyle}>Seomatic is an on-page and SERP SEO toolbar. It analyzes the pages you visit in your browser: content, indexability, structured data, social tags, images, links, HTTP headers, redirects, and performance signals. We do not operate servers for this extension, we do not require an account or API key, and we do not collect, upload, store, or transmit page content, browsing history, or personal information to us or to any analytics, advertising, or tracking service.</p>
        <p style={paragraphStyle}>The extension does not use analytics, advertising, tracking, or remote logging.</p>

        <h2 style={headerStyle}>2. Local Processing and Storage</h2>
        <p style={paragraphStyle}>Page analysis runs in your browser. Extracted SEO data is shown in the on-page panel, metrics bar, and SERP overlay on your device. It is not sent to us.</p>
        <p style={paragraphStyle}>Preferences (such as language, theme, panel layout, enabled tabs, highlight options, link-check settings, SERP options, and User-Agent profiles) and any URL lists you save are stored locally with Chrome storage on your device. You can clear them by removing the extension or clearing extension data in Chrome.</p>

        <h2 style={headerStyle}>3. Network Requests</h2>
        <p style={paragraphStyle}>The extension makes network requests only as needed to inspect the page you are analyzing. Those requests go to that page and related resources on its own domain or to URLs found on the page, for example:</p>
        <ul>
            <li style={paragraphStyle}>HTTP status, response headers, and redirect chains</li>
            <li style={paragraphStyle}>robots.txt and sitemap files for the site you are viewing</li>
            <li style={paragraphStyle}>Broken-link checks against links on the page</li>
            <li style={paragraphStyle}>Fetching raw HTML to compare it with the rendered DOM</li>
        </ul>
        <p style={paragraphStyle}>These requests are made from your browser to those sites. They are not sent to our servers. If you click an optional validator or tools link (for example PageSpeed Insights or a rich-results tester), you leave the extension and that third party&apos;s own privacy policy applies.</p>
        <p style={paragraphStyle}>Country search and User-Agent simulation change how your browser requests search or page content (for example country/language parameters or a simulated crawler User-Agent). That traffic still goes to the site you chose, not to us.</p>

        <h2 style={headerStyle}>4. Permissions</h2>
        <p style={paragraphStyle}>The extension requests permissions needed for on-page SEO analysis, SERP overlays, link checks, header inspection, and User-Agent simulation:</p>
        <ul>
            <li style={paragraphStyle}><strong>storage:</strong> Save preferences and saved URL lists locally.</li>
            <li style={paragraphStyle}><strong>activeTab / scripting / tabs:</strong> Read the current page and inject the report UI when you use the toolbar.</li>
            <li style={paragraphStyle}><strong>webRequest:</strong> Observe HTTP headers and redirect chains for the pages you inspect.</li>
            <li style={paragraphStyle}><strong>declarativeNetRequest / declarativeNetRequestWithHostAccess:</strong> Apply User-Agent simulation rules when you enable that feature.</li>
            <li style={paragraphStyle}><strong>Host access (&lt;all_urls&gt;):</strong> Analyze any site you open, check links, fetch robots.txt/sitemaps/raw HTML, and overlay SERP chips on search result pages. A content script loads on pages so the toolbar can run without a separate click each time.</li>
        </ul>

        <h2 style={headerStyle}>5. Data Sharing</h2>
        <p style={paragraphStyle}>We do not share your data with third parties. The extension has no developer backend and does not transmit analysis results to us.</p>

        <h2 style={headerStyle}>6. Data Security</h2>
        <p style={paragraphStyle}>Because analysis and preference storage happen locally in your browser, page content and settings are not transmitted to our systems. You remain responsible for how you export CSV/TXT files or share URLs you save.</p>

        <h2 style={headerStyle}>7. Changes to this Policy</h2>
        <p style={paragraphStyle}>We may update this Privacy Policy from time to time. Significant changes will be communicated through the Chrome Web Store listing or our website.</p>

        <h2 style={headerStyle}>8. Contact Us</h2>
        <p style={paragraphStyle}>If you have any questions about this Privacy Policy, please contact us at <a style={linkStyle} href="mailto:mehmetalicelebii@gmail.com">mehmetalicelebii@gmail.com</a>.</p>
    </div>
  );
};

export default PrivacyPolicySeomatic;
